/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import * as React from 'react';
import { IMoeV2BackToTopViewProps } from './moe-v2-back-to-top';

export default (props: IMoeV2BackToTopViewProps) => {
    const [isVisible, setIsVisible] = React.useState(false);
    const threshold = props.config.showThreshold || 300;

    React.useEffect(() => {
        const toggleVisibility = () => {
            const scrollPos = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
            if (scrollPos > threshold) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        // Initial check
        toggleVisibility();

        // Add listeners to multiple targets for cross-site compatibility
        window.addEventListener('scroll', toggleVisibility);
        document.addEventListener('scroll', toggleVisibility);
        document.body.addEventListener('scroll', toggleVisibility);

        return () => {
            window.removeEventListener('scroll', toggleVisibility);
            document.removeEventListener('scroll', toggleVisibility);
            document.body.removeEventListener('scroll', toggleVisibility);
        };
    }, [threshold]);

    const scrollToTop = () => {
        // Try multiple scroll methods for cross-site compatibility
        window.scrollTo({ top: 0, behavior: 'smooth' });
        document.documentElement.scrollTo({ top: 0, behavior: 'smooth' });
        document.body.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div>
            {isVisible && (
                <div className='moe-v2-back-to-top-container'>
                    <button className='moe-v2-back-to-top' onClick={scrollToTop} type='button'>
                        <svg width='20px' height='20px' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                            <g strokeWidth='0' />
                            <g strokeLinecap='round' strokeLinejoin='round' />
                            <g>
                                <path
                                    d='M8 12L12 8M12 8L16 12M12 8V20M4 4H20'
                                    stroke='#ffffff'
                                    strokeWidth='2'
                                    strokeLinecap='round'
                                    strokeLinejoin='round'
                                />
                            </g>
                        </svg>
                    </button>
                </div>
            )}
        </div>
    );
};
